import React from 'react';
import { observable, makeObservable } from 'mobx';
import _ from 'lodash';
import createContextHelpers from 'shared/helpers/context';

class IsolatedCheckout {
  @observable addressPopulatedFromServer = false;
  @observable loading = true;

  constructor() {
    makeObservable(this);
  }
}

export const isolatedContextStore = new IsolatedCheckout();
const IsolatedCheckoutContext = React.createContext();
export const { IsolatedCheckoutProvider, useIsolatedCheckout, withIsolatedCheckout } = createContextHelpers(
  IsolatedCheckoutContext,
  'isolatedCheckout'
);
